export const ITEM_CATEGORY_TYPES = ["in-kind", "scrap"] as const;

export type ItemCategoryType = (typeof ITEM_CATEGORY_TYPES)[number];

export const ITEM_CATEGORY_TYPE_OPTIONS: {
  value: ItemCategoryType;
  label: string;
}[] = [
  { value: "in-kind", label: "In-Kind" },
  { value: "scrap", label: "Scrap" },
];

export interface ItemCategoryPayload {
  item_category_type: ItemCategoryType;
  name: string;
  description?: string;
  is_active: boolean;
}

export interface ItemCategoryRecord extends ItemCategoryPayload {
  id: number;
  created_at?: string;
  updated_at?: string;
}
